import 'angular-gettext';
import preferencesOrganizations, { OrganizationsService } from '../organizations.service';

class InviteController {
    saving: boolean;
    email: string;
    constructor(
        private gettextCatalog: ng.gettext.gettextCatalog,
        private preferencesOrganizations: OrganizationsService,
    ) {
        this.saving = false;
        this.email = '';
    }
    sendInvite(): ng.IPromise<void> {
        this.saving = true;
        const successMessage = this.gettextCatalog.getString('{{app_name}} sent an invite to {{email}}', {
            email: this.email,
            app_name: process.env.APP_NAME,
        });
        const errorMessage = this.gettextCatalog.getString(
            "{{app_name}} couldn't send an invite (check to see if email address is valid)",
            {
                app_name: process.env.APP_NAME,
            },
        );
        return this.preferencesOrganizations
            .createInvite(this.email, successMessage, errorMessage)
            .then(() => {
                this.saving = false;
                this.email = '';
            })
            .catch((err) => {
                this.saving = false;
                throw err;
            });
    }
}

const Invite = {
    controller: InviteController,
    template: require('./invite.html'),
};

export default angular
    .module('mpdx.preferences.organizations.invite.component', ['gettext', preferencesOrganizations])
    .component('inviteOrganizationsPreferences', Invite).name;
